// extracted by mini-css-extract-plugin
export var errorsContainer = "_sv-1";
export var link = "_sv-0";